import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { ThemeProvider, CssBaseline, GlobalStyles } from "@mui/material";
import portantTheme, { portant } from "./theme/portantTheme";

/* global document, Office, module, require, HTMLElement */

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

/* Render application after Office initializes */
Office.onReady(() => {
  root?.render(
    <ThemeProvider theme={portantTheme}>
      <CssBaseline />
      <GlobalStyles styles={{ body: { backgroundColor: portant.canvas } }} />
      <FluentProvider theme={webLightTheme} style={{ background: "transparent" }}>
        <App />
      </FluentProvider>
    </ThemeProvider>
  );
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(NextApp);
  });
}
